import useSound from 'use-sound';
import useSoundStore from '../../../stores/useSoundStore';

export interface UseQuestRewardSoundsResult {
  playExpGift: () => void;
  playCurrencyGift: () => void;
}

export function useQuestRewardSounds(): UseQuestRewardSoundsResult {
  const { soundsEnabled } = useSoundStore();
  const [playExpGift] = useSound('/exp-gift.mp3', {
    volume: 0.026,
    soundEnabled: soundsEnabled,
  });
  const [playCurrencyGift] = useSound('/currency-gift.mp3', {
    volume: 0.039,
    soundEnabled: soundsEnabled,
  });

  return {
    playExpGift,
    playCurrencyGift,
  };
}
